import { render, staticRenderFns } from "./Create-Broadcast.vue?vue&type=template&id=fc4fae02&scoped=true&"
import script from "./Create-Broadcast.vue?vue&type=script&lang=js&"
export * from "./Create-Broadcast.vue?vue&type=script&lang=js&"
import style0 from "./Create-Broadcast.vue?vue&type=style&index=0&id=fc4fae02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4fae02",
  null
  
)

export default component.exports